import { createFileRoute } from "@tanstack/react-router";
import { pickPeekSearch } from "@/lib/peek-search";

export const Route = createFileRoute("/$owner/chat/$agentId/c/$threadId")({
	validateSearch: (search: Record<string, unknown>) => {
		const out: Record<string, string | undefined> = {
			...pickPeekSearch(search),
		};
		const messageId =
			(typeof search.message_id === "string" && search.message_id.trim()) ||
			(typeof search.message === "string" && search.message.trim()) ||
			"";
		if (messageId) out.message_id = messageId;
		return out;
	},
	component: () => null,
});
